export default __webpack_public_path__ + "static/74838-073cb802958776e599ce8016a8454aa2.jpg";